<!-- Pop up for assignment status change -->
<dx-popup
  width="500px"
  height="700px"
  [showTitle]="true"
  [title]="'PROJECT_PLANNING.COMPLETE_ASSIGNMENT' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [visible]="visible()"
  [shading]="true"
  [contentTemplate]="'content'"
  (onHiding)="handlePopupHide()">
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="top"
    location="after"
    [options]="{ icon: 'close', onClick: closeDialog.bind(this) }">
  </dxi-toolbar-item>
  <div class="complete-assignment-dialog">
    <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>

    <!-- Radio-Group: -->
    <dx-radio-group
      [items]="assignmentCompleteOptions()"
      [valueExpr]="'value'"
      [displayExpr]="'display'"
      [value]="assignmentCompleteData().CompletionOption"
      (onValueChanged)="radioGroupValueChanged($event)">
    </dx-radio-group>

    <!-- Comment text field -->
    <dx-text-area
      [maxLength]="500"
      [minHeight]="120"
      [autoResizeEnabled]="true"
      [label]="'Kommentar'"
      [value]="assignmentCompleteData().Comment || ''"
      (onValueChanged)="onCommentChange($event.value)"></dx-text-area>

    <!--Button complete  -->
    <dx-button text="Fertig" (onClick)="handleSendStatusChange()"></dx-button>
  </div>
</dx-popup>
